import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-circle-x-icon lucide-circle-x"
}




export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false
},
  __name: 'CloseIcon',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, -1),
    _createElementVNode("path", { d: "m15 9-6 6" }, null, -1),
    _createElementVNode("path", { d: "m9 9 6 6" }, null, -1)
  ]))]))
}
}

})